var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockedLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 50,
    viewBox: "0 0 100 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.6.6")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 19.72 12.5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -0.49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(13,34,62)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-12, -12.01)",
    d: "M 15.3314 22.2396 C 11.359 22.2396 8.13736 19.1121 8.13736 15.2549 C 8.13736 11.3983 11.359 8.27077 15.3314 8.27077 C 17.5914 8.27077 19.6072 9.2825 20.9261 10.8652 L 12.4802 18.5456 C 14.5641 20.4489 19.6128 19.9637 20.0152 14.1418 L 22.4163 14.037 C 22.4879 14.4322 22.5259 14.8398 22.5259 15.2549 C 22.5259 19.1121 19.3042 22.2396 15.3314 22.2396 M 12 0.00598145 C 5.37258 0.00598145 0 5.3785 0 12.006 C 0 18.6335 5.37258 24.006 12 24.006 C 18.6274 24.006 24 18.6335 24 12.006 C 24 5.3785 18.6274 0.00598145 12 0.00598145",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.81 1.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(13,34,62)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-13.81, -13.6)",
    d: "M 15.0946 10.808 C 12.7258 10.9141 10.8047 12.7422 10.8047 14.8897 C 10.8047 15.4334 10.9281 15.9449 11.1504 16.405 L 16.8074 11.0534 C 16.2827 10.8694 15.7037 10.7806 15.0946 10.808",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.04 0 0 0.04 8.5 14.85)",
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 2,
      strokeDasharray: "",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-243.37, -243.37)",
    d: "M 403.88 196.563 h -9.484 v -44.388 c 0 -82.099 -65.151 -150.681 -146.582 -152.145 c -2.225 -0.04 -6.671 -0.04 -8.895 0 C 157.486 1.494 92.336 70.076 92.336 152.175 v 44.388 h -9.485 c -14.616 0 -26.538 15.082 -26.538 33.709 v 222.632 c 0 18.606 11.922 33.829 26.539 33.829 h 321.028 c 14.616 0 26.539 -15.223 26.539 -33.829 V 230.272 C 430.419 211.646 418.497 196.563 403.88 196.563 z M 273.442 341.362 v 67.271 c 0 7.703 -6.449 14.222 -14.158 14.222 H 227.45 c -7.71 0 -14.159 -6.519 -14.159 -14.222 v -67.271 c -7.477 -7.36 -11.83 -17.537 -11.83 -28.795 c 0 -21.334 16.491 -39.666 37.459 -40.513 c 2.222 -0.09 6.673 -0.09 8.895 0 c 20.968 0.847 37.459 19.179 37.459 40.513 C 285.272 323.825 280.919 334.002 273.442 341.362 z M 331.886 196.563 h -84.072 h -8.895 h -84.072 v -44.388 c 0 -48.905 39.744 -89.342 88.519 -89.342 c 48.775 0 88.521 40.437 88.521 89.342 V 196.563 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedLogoSmall);
export default __webpack_public_path__ + "static/media/locked-logo-small.fa89c2e964883d12fd4bc84ee9b783a2.svg";
export { ForwardRef as ReactComponent };